import { css } from 'styled-components'

/**
 * Shared chrome for list tables and their loading skeletons, so they can never
 * visually drift apart.
 */
export const listTableStyles = css`
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  overflow: hidden;

  .ant-table-thead > tr > th {
    background: #edf1f6 !important;
    color: #173663 !important;
    font-weight: 500 !important;
    padding: 8px 12px;
  }

  .ant-table-thead > tr > th.no-wrap-header {
    white-space: nowrap;
  }

  .ant-table-tbody > .ant-table-row > td {
    background-color: #ffffff !important;
    border-bottom: 1px solid #f5f5f5;
    color: #0f2242;
    font-weight: 400;
    height: 72px;
    padding: 0 12px;
    overflow: hidden;
  }

  .ant-table-tbody > .ant-table-row:hover > td {
    background-color: #edf1f6 !important;
  }
`
